"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolicyConfirmationDocumentMap = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_policy_confirmation_entity_1 = require("./opportunity-policy-confirmation.entity");
const file_upload_entity_1 = require("./file-upload.entity");
let PolicyConfirmationDocumentMap = class PolicyConfirmationDocumentMap {
};
exports.PolicyConfirmationDocumentMap = PolicyConfirmationDocumentMap;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], PolicyConfirmationDocumentMap.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "policy_confirmation_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], PolicyConfirmationDocumentMap.prototype, "policyConfirmationId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "document_type_lid", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], PolicyConfirmationDocumentMap.prototype, "documentTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "document_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], PolicyConfirmationDocumentMap.prototype, "documentId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_policy_confirmation_entity_1.OpportunityPolicyConfirmation, (policyConfirmation) => policyConfirmation.documents, { onDelete: "CASCADE" }),
    (0, typeorm_1.JoinColumn)({ name: "policy_confirmation_id" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Relation !== "undefined" && Relation) === "function" ? _a : Object)
], PolicyConfirmationDocumentMap.prototype, "policyConfirmation", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => file_upload_entity_1.FileUpload, { onDelete: "CASCADE" }),
    (0, typeorm_1.JoinColumn)({ name: "document_id" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Relation !== "undefined" && Relation) === "function" ? _b : Object)
], PolicyConfirmationDocumentMap.prototype, "document", void 0);
exports.PolicyConfirmationDocumentMap = PolicyConfirmationDocumentMap = tslib_1.__decorate([
    (0, typeorm_1.Entity)({ name: "policy_confirmation_document_map" })
], PolicyConfirmationDocumentMap);
